import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import api from "../../../api/api";
import { useReactToPrint } from "react-to-print";
import { useRef } from "react";
const NewsList = () => {
  const [newsData, setNewsData] = useState([]);
  const [deleteResp, setDeleteResp] = useState(false);
  const [viewMore, setViewMore] = useState(true);

  const printRef=useRef()
  const print=useReactToPrint({
    content:()=>printRef.current
  })
  useEffect(() => {
    api
      .get("/news/")
      .then((response) => {
        // console.log(response.data);
        setNewsData(response.data);
      })
      .catch((error) => {
        toast.error("Something went wrong");
      });
  }, [deleteResp]);

  const handleData = (id) => {
    // alert(id)
    api
      .delete(`/news/${id}/`)
      .then((response) => {
        setDeleteResp(!deleteResp);
      })
      .catch((error) => {
        toast.error("Something went wrong");
      });
  };

  const handleSearch = (e) => {
    api
      .get(`/news/?search=${e.target.value}`)
      .then((response) => {
        // console.log(response.data);
        setNewsData(response.data)
      })
      .catch((error) => {});
  };

  return (
    <div className="">
      <h1 className="text-primary-red mt-2 text-center text-3xl font-bold lg:!mt-6">
        Posted News List
      </h1>
      <div className="">
        <img
          src="../../images/title-border.png"
          alt=""
          className="mx-auto mt-4"
        />
      </div>
      {/* table  */}
      <div className="mt-3 w-full md:px-10">
        <div className="flex flex-col">
          <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="inline-block min-w-full py-4 sm:px-6 lg:px-8">
              <div className="overflow-hidden">
                {/* search */}
                <div className="flex flex-wrap items-center justify-between">
                  <input
                    type="text"
                    placeholder="Search by date "
                    id="table-search"
                    onChange={(e) => handleSearch(e)}
                    // onClick=((e)=> handleSearch(e.target.value))
                    className="mb-2 block w-80 rounded-lg border border-gray-700 bg-gray-50 py-2.5 px-3 text-sm focus:border-blue-500 focus:ring-blue-500"
                  />
                  <input
                    type="text"
                    placeholder="Search by name "
                    id="table-search"
                    onChange={(e) => handleSearch(e)}
                    className="mb-2 block w-80 rounded-lg border border-gray-700 bg-gray-50 py-2.5 px-3 text-sm focus:border-blue-500 focus:ring-blue-500"
                  />
                  <input
                    type="text"
                    placeholder="Search by category "
                    id="table-search"
                    onChange={(e) => handleSearch(e)}
                    className="mb-2 block w-80 rounded-lg border border-gray-700 bg-gray-50 py-2.5 px-3 text-sm focus:border-blue-500 focus:ring-blue-500"
                  />
                  <input
                    type="text"
                    placeholder="Search by author "
                    id="table-search"
                    onChange={(e)=> handleSearch(e)}
                    className="mb-2 block w-80 rounded-lg border border-gray-700 bg-gray-50 py-2.5 px-3 text-sm focus:border-blue-500 focus:ring-blue-500"
                  />
                </div>
                <table ref={printRef} className="min-w-full text-center">
                  <thead className="font-Bree bg-primary-red border-b font-bold">
                    <tr>
                      <th
                        scope="col"
                        className="px-6 py-4 text-sm font-medium text-white"
                      >
                        SN.
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-4 text-sm font-medium text-white"
                      >
                        News no
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-4 text-sm font-medium text-white"
                      >
                        Post Date
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-4 text-sm font-medium text-white"
                      >
                        News Heading
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-4 text-sm font-medium text-white"
                      >
                        News Category
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-4 text-sm font-medium text-white"
                      >
                        Author Name
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-4 text-sm font-medium text-white"
                      >
                        Action
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-4 text-sm font-medium text-white"
                      >
                        Status
                      </th>
                    </tr>
                  </thead>
                  <tbody className="font-Acme">
                    {/* remaining task */}
                    {newsData.length < 1 && (
                      <h1 className="w-full text-center">NO data to show </h1>
                    )}
                    {newsData
                      .slice(0, `${viewMore ? 10 : newsData.length}`)
                      .map((item, i) => {
                        return (
                          <tr className="border-b bg-white" key={i}>
                            <td className="whitespace-nowrap px-6 py-4 text-sm font-light text-gray-900">
                              {i + 1}
                            </td>
                            <td className="whitespace-nowrap px-6 py-4 text-sm font-light text-gray-900">
                              {item.id}
                            </td>
                            <td className="whitespace-nowrap px-6 py-4 text-sm font-light text-gray-900">
                              {item.created_at}
                            </td>
                            <td className="whitespace-nowrap px-6 py-4 text-sm font-light text-gray-900">
                              {item.title}
                            </td>
                            <td className="whitespace-nowrap px-6 py-4 text-sm font-light text-gray-900">
                              {item.category_name_nep}
                            </td>
                            <td className="whitespace-nowrap rounded-full py-2 px-4 text-sm">
                              {item.author_name}
                            </td>

                            <td className="whitespace-nowrap rounded-full py-2 px-4 text-sm">
                              {/* <buttom className="bg-red-500 mr-2 text-white p-1 rounded-lg hover:bg-primary-blue cursor-pointer ">
                                edit
                              </buttom> */}

                              {/* Delete Modal */}
                              <buttom
                                data-bs-toggle="modal"
                                data-bs-target="#DeleteLinkModalDemo"
                                className="bg-red-500 text-white p-1 rounded-lg hover:bg-primary-blue cursor-pointer "
                              >
                                delete
                              </buttom>
                              <div
                                className="modal fade fixed top-0 left-0 hidden h-full w-full overflow-y-auto overflow-x-hidden outline-none"
                                id="DeleteLinkModalDemo"
                                tabIndex={-1}
                                aria-labelledby="exampleModalLabel"
                                aria-modal="true"
                                role="dialog"
                              >
                                <div className="modal-dialog modal-lg pointer-events-none relative w-auto">
                                  <div className="modal-content pointer-events-auto relative flex w-full flex-col rounded-md border-none bg-white bg-clip-padding text-current shadow-lg outline-none">
                                    <div className="flex justify-end">
                                      <svg
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                        className="text-primary-blue h-8 w-8"
                                        xmlns="http://www.w3.org/2000/svg"
                                        aria-hidden="true"
                                        role="img"
                                        preserveAspectRatio="xMidYMid meet"
                                        viewBox="0 0 24 24"
                                      >
                                        <path
                                          fill="currentColor"
                                          d="m13.41 12l4.3-4.29a1 1 0 1 0-1.42-1.42L12 10.59l-4.29-4.3a1 1 0 0 0-1.42 1.42l4.3 4.29l-4.3 4.29a1 1 0 0 0 0 1.42a1 1 0 0 0 1.42 0l4.29-4.3l4.29 4.3a1 1 0 0 0 1.42 0a1 1 0 0 0 0-1.42Z"
                                        />
                                      </svg>
                                    </div>
                                    <div className="modal-header rounded-t-md  border-gray-200 text-2xl text-">
                                      Are you sure want to Delete Link ?
                                    </div>
                                    <div className="flex justify-center gap-2 my-3">
                                      <div
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                        className="bg-red-600 text-white rounded-2xl p-2 cursor-pointer "
                                        onClick={() => {
                                          handleData(item.id);
                                        }}
                                      >
                                        Delete
                                      </div>

                                      <div
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                      >
                                        <div className="bg-red-600 text-white rounded-2xl p-2 cursor-pointer ">
                                          Cancel
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </td>
                            <td className="text-primary-blue whitespace-nowrap rounded-full py-2 px-4 text-sm font-bold">
                              {item.is_published ? <>Show</> : <>Hidden</>}
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
                <div className="bg-primary-blue ml-10 mt-3 inline-flex gap-2 rounded-md px-5 py-3 font-bold text-white">
                  <button onClick={print}>Print</button>
                </div>
                <div className="bg-primary-green ml-10 mt-3 inline-flex gap-2 rounded-md px-5 py-3 font-bold text-white">
                  {/* <a href="">View More</a>
                   */}

                  {viewMore ? (
                    <button onClick={() => setViewMore(false)}>
                      View More
                    </button>
                  ) : (
                    <button onClick={() => setViewMore(true)}>View Less</button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* end table */}
    </div>
  );
};

export default NewsList;
